<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import pagination from "laravel-vue-pagination";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import {
  get_partner_login,
  set_partner,
  set_partner_details,
  set_user,
  set_user_detail,
  debounce,
  get_decimal,
  get_currency,
  date_ranges,
} from "../../Helper/helper";
import moment from "moment";
import { reportService, deliveryZoneService } from "../../services";
/**
 * Report component
 */
export default {
  components: { Layout, PageHeader, pagination, DateRangePicker },
  data() {
    let startDate = this.moment().startOf("day").subtract(29, "days");
    let endDate = this.moment().endOf("day").toDate();
    return {
      decimal: get_decimal(),
      taxReport: {},
      taxReports: [],
      sortBy: "id",
      sortDesc: true,
      restaurant: [],
      restaurant_count: "",
      restaurants_id: "",
      paginations: {},
      limit: 2,
      currency: get_currency(),
      countries: [],
      country: 0,
      states: [],
      state: 0,
      cities: [],
      city: 0,
      country_count: "",
      state_count: "",
      city_count: "",
      loading: true,
      isDownloading: false,
      dateRange: { startDate, endDate },
      filters: {
        start_date: this.moment().subtract(29, "days").format("YYYY-MM-DD"),
        end_date: this.moment().format("YYYY-MM-DD"),
      },
      date_ranges: date_ranges,
      fields: [
        { key: "user_id", label: "#", sortable: false,thClass:"dis-event" },
        { key: "id", label: "Order ID", sortable: true },
        { key: "created_date", label: "Order Date", sortable: true },
        { key: "sub_total", label: "Item Price", sortable: true },
        { key: "total_vat", label: "Tax", sortable: true },
        { key: "item_total", label: "Item Total", sortable: true },
      ],
    };
  },
  mounted() {
    // this.gettaxReports();
    this.getVendorCountry();
    // this.getRestaurants();
    // this.taxReportExportCsv();
  },
  methods: {
    downloadsCSV: function () {
      let taxReports =
        "\ufeff" + "Order ID,Order Date,Item Price,Tax,Item Total\n";
      this.taxReports.forEach((el) => {
        var line =
          el["id"] +
          "," +
          el["created_date"] +
          "," +
          this.currency +
          " " +
          el["sub_total"].toFixed(2) +
          "," +
          this.currency +
          " " +
          el["total_vat"].toFixed(2) +
          "," +
          this.currency +
          " " +
          el["item_total"].toFixed(2) +
          "\n";
        taxReports += line;
      });

      var blob = new Blob([taxReports], { type: "csv/plain" });
      var date = new Date().toLocaleString();
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "tax_report_" + date + ".csv";
      link.click();
    },
    updateValues(date) {
      this.filters = {
        ...this.filters,
        start_date: this.moment(date.startDate.toISOString()).format(
          "YYYY-MM-DD"
        ),
        end_date: this.moment(date.endDate.toISOString()).format("YYYY-MM-DD"),
      };
      this.gettaxReports();
      // this.taxReportExportCsv();
    },
    dateFormat(classes, date) {
      this.filters = {
        ...this.filters,
        start_date: this.moment(date.startDate.toISOString()).format(
          "YYYY-MM-DD"
        ),
        end_date: this.moment(date.endDate.toISOString()).format("YYYY-MM-DD"),
      };
    },
    gettaxReports(page) {
      this.loading = true;
      reportService
        .getTaxReport({
          ...this.filters,
          sortBy: this.sortBy,
          orderBy: this.sortDesc ? "desc" : "asc",
          country: this.country,
          state: this.state,
          city: this.city,
          restaurants_id: this.restaurants_id,
          page: page ? page : 1,
        })
        .then((response) => {
          this.loading = false;
          // this.paginations = response.data.result;
          this.taxReport = response.data.result;
        });
    },
    getVendorCountry() {
      this.country = 0;
      this.city = 0;
      this.state = 0;
      this.countries = [];
      this.states = [];
      this.cities = [];
      deliveryZoneService.getVendorCountry().then((response) => {
        this.countries = response.data.result;
        if (this.countries.length == 1) {
          this.country = this.countries[0].id;
        }
        this.getVendorState();
      });
    },
    taxReportExportCsv() {
      this.isDownloading = true;
      reportService
        .taxReportExportToCsv({
          ...this.filters,
          restaurants_id: this.restaurants_id,
          sortBy: this.sortBy,
          orderBy: this.sortDesc ? "desc" : "asc",
        })
        .then((response) => {
          this.isDownloading = false;
          this.taxReports = response.data.result;
          this.downloadsCSV();
        });
    },
    getRestaurants() {
      this.restaurant = [];
      reportService
        .getRestaurantsConfirm({
          country_id: this.country,
          state_id: this.state,
          city_id: this.city,
        })
        .then((response) => {
          this.restaurant = response.data.result;
          this.restaurant_id = this.restaurant[0].restaurant_id;
          this.searchData();
        });
    },
    getVendorState() {
      this.city = 0;
      this.state = 0;
      this.states = [];
      this.cities = [];
      this.country = parseInt(this.country);
      if (this.country > 0) {
        deliveryZoneService
          .getVendorState({ country_id: this.country })
          .then((response) => {
            this.states = response.data.result;
            if (this.states.length == 1) {
              this.state = this.states[0].id;
            }
            this.getVendorCity();
          });
      } else {
        this.searchData();
      }
    },
    getVendorCity() {
      this.city = 0;
      this.cities = [];
      this.state = parseInt(this.state);
      if (this.state > 0) {
        deliveryZoneService
          .getVendorCity({
            state_id: this.state ? this.state : 0,
            country_id: this.country,
          })
          .then((response) => {
            this.cities = response.data.result;
            if (this.cities.length == 1) {
              this.city = this.cities[0].cityid;
            }
            this.searchData();
            this.getRestaurants();
          });
      } else {
        this.searchData();
        this.getRestaurants();
      }
    },
    citychange() {
      this.searchData();
      this.getRestaurants();
    },
    searchData() {
      this.gettaxReports();
      // this.taxReportExportCsv();
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.gettaxReports();
    },
  },
  filters: {
    date(val) {
      return val ? val.toLocaleString() : "";
    },
  },
};
</script>

<template>
  <Layout>
    <div>
      <div class="row">
        <div class="col-12">
          <div
            class="
              page-title-box
              d-flex
              align-items-center
              justify-content-between
              icon-main-page
            "
          >
            <div class="page-title-left avatar-main-icon">
              <div class="avatar-xs mr-3">
                <span
                  class="
                    avatar-title
                    rounded-circle
                    bg-soft-primary
                    text-primary
                    font-size-18
                  "
                >
                  <i class="bx bx-purchase-tag"></i>
                </span>
              </div>
              <div class="report-tag">
                <h4 class="mb-0 font-size-18">
                  {{ trans.get("__JSON__.Tax Report") }}
                </h4>
                <p>
                  <router-link :to="{ name: 'reports-list' }">{{
                    trans.get("__JSON__.Reports")
                  }}</router-link>
                  > {{ trans.get("__JSON__.Tax Report") }}
                </p>
              </div>
            </div>
            <div class="page-title-right">
              <button
                @click="taxReportExportCsv"
                class="btn btn-primary btn-rounded export-btn"
                v-if="isDownloading"
                disabled
              >
                {{ trans.get("__JSON__.Exporting...") }}
              </button>
              <button
                @click="taxReportExportCsv"
                class="btn btn-primary btn-rounded export-btn"
                v-else
              >
                {{ trans.get("__JSON__.Export To CSV") }}
              </button>
              <button
                @click="taxReportExportCsv"
                class="btn btn-primary btn-rounded m-export-btn mb-4"
              >
                <i class="bx bx-archive-in"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- end row -->
      <div class="row">
        <div class="col-12 list-table-main">
          <div class="card">
            <div class="card-body">
              <div class="row justify-content-end">
                <!-- <div v-if="countries.length >1" class="tax-report">
                  <div class="form-group">
                    <div class="date-range-list">
                      <label>{{ trans.get('__JSON__.Country') }} :</label>
                      <select class="custom-select" v-model="country" @change="getVendorState">
                        <option value="0" selected>All</option>
                        <option
                          v-for="con in countries"
                          :value="con.id"
                          :key="con.id"
                        >{{con.country_name}}</option>
                      </select>
                    </div>
                  </div>
                </div> -->
                <!-- <div v-else class="offset-sm-2">
                </div> -->
                <!-- <div v-if="states.length >1" class="tax-report">
                  <div class="form-group">
                    <div class="date-range-list">
                      <label>{{ trans.get('__JSON__.State') }} :</label>
                      <select class="custom-select" v-model="state" @change="getVendorCity">
                        <option value="0" selected>All</option>
                        <option
                          v-for="sat in states"
                          :value="sat.id"
                          :key="sat.id"
                        >{{sat.state_name}}</option>
                      </select>
                    </div>
                  </div>
                </div> -->
                <!-- <div v-else class="offset-sm-2">
                </div> -->
                <!-- <div v-if="cities.length >1" class="tax-report">
                  <div class="form-group">
                    <div class="date-range-list">
                      <label>{{ trans.get('__JSON__.City') }} :</label>
                      <select class="custom-select" v-model="city" @change="citychange">
                        <option value="0" selected>All</option>
                        <option
                          v-for="cit in cities"
                          :value="cit.cityid"
                          :key="cit.cityid"
                        >{{cit.cityname}}</option>
                      </select>
                    </div>
                  </div>
                </div> -->
                <!-- <div v-else class="offset-sm-2">
                </div> -->
                <!-- <div v-if="(countries.length >1 || states.length > 1 || cities.length > 1) && restaurant.length > 1" class="tax-report">
                  <div class="form-group">
                    <div class="date-range-list">
                      <label>{{ trans.trans('__JSON__.Vendor',{ vendor: $auth.setting.restaurant_name }) }} :</label>
                      <select class="custom-select" v-model="restaurants_id" @change="searchData()">
                        <option value selected>{{ trans.trans('__JSON__.All Vendor',{ vendor: $auth.setting.restaurant_name }) }}</option>
                        <option v-for="res in restaurant" :value="res.restaurant_id" :key="res.restaurant_id">{{res.name}}</option>
                      </select>
                    </div>
                  </div>
                </div> -->
                <div class="tax-report">
                  <div class="form-group">
                    <div class="date-range-list">
                      <label>{{ trans.get("__JSON__.Date") }}:</label>
                      <date-range-picker
                        ref="picker"
                        :locale-data="{
                          firstDay: 1,
                          format: 'dd-mm-yyyy',
                        }"
                        :showDropdowns="true"
                        :showWeekNumbers="true"
                        opens="left"
                        v-model="dateRange"
                        :ranges="date_ranges()"
                        @update="updateValues"
                      >
                        <template
                          v-slot:input="picker"
                          style="min-width: 350px"
                        >
                          {{
                            moment(picker.startDate.toISOString()).format(
                              "MMMM DD, YYYY"
                            ) | date
                          }}
                          -
                          {{
                            moment(picker.endDate.toISOString()).format(
                              "MMMM DD, YYYY"
                            ) | date
                          }}
                        </template>
                      </date-range-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="
                    col-12
                    table-main-list
                    tax-report-table
                    table-responsive
                  "
                >
                  <b-table
                    :items="taxReport.data"
                    :fields="fields"
                    :sort-by.sync="sortBy"
                    :no-local-sorting="true"
                    @sort-changed="sortingChanged"
                    :busy="loading"
                    show-empty
                  >
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>{{ trans.get("__JSON__.Loading...") }}</strong>
                      </div>
                    </template>

                    <template v-slot:cell(user_id)="data">
                      <div>
                        {{
                          taxReport.per_page * (taxReport.current_page - 1) +
                          data.index +
                          1
                        }}
                      </div>
                    </template>

                    <template v-slot:cell(name)="data">
                      <span>{{ data.item.name }}</span>
                    </template>

                    <template v-slot:cell(sub_total)="data">
                      <span v-html="currency"></span>
                      {{ data.item.sub_total.toFixed(2) || "0.00" }}
                    </template>

                    <template v-slot:cell(admin_commision)="data">
                      <span v-html="currency"></span>
                      {{ data.item.admin_commision || "0.00" }}
                    </template>

                    <template v-slot:cell(item_total)="data">
                      <span v-html="currency"></span>
                      {{ data.item.item_total.toFixed(2) }}
                    </template>

                    <template v-slot:cell(total_vat)="data">
                      <span v-html="currency"></span>
                      {{ data.item.total_vat.toFixed(2) }}
                    </template>

                    <template #empty>
                      <p class="text-center">
                        {{ trans.get("__JSON__.No Tax Report Found") }}
                      </p>
                    </template>
                  </b-table>
                </div>
                <div class="row col-sm-5 offset-sm-7">
                  <div class="col">
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-right
                      "
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <pagination
                          :data="taxReport"
                          :limit="limit"
                          @pagination-change-page="gettaxReports"
                        ></pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
/* .tax-report-table .table thead th:nth-child(1),
.tax-report-table .table thead th:nth-child(4) {
  pointer-events: none;
} */
</style>